
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getUploadsForRegion",
      resolverType: "query",
      routePath: "/getUploadsForRegion",
      httpMethod: "POST",
    });
  